import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

export const ns = 'navigation';
export const useNavigationTranslation = (): UseTranslationResponse<
  typeof ns
> => useTranslation(ns);

const reused = {
  accounts: '$t(пользователи)',
  workspace: '$t(панель оператора)',
  fs_event_archive: '$t(архив событий)',
  va_event_archive: '$t(архив видеоаналитик)',
  videowall: '$t(видеостена)',
  search: '$t(поиск)',
  fs_event_statistic: '$t(статистика)',
  fs_sources: '$t(источники событий)',
  va_sources: '$t(видеоаналитики)',
  vms: '$t(common:vms)',
  handlers: '$t(сценарии)',
  tasks: '$t(задачи)',
  monitoring: '$t(мониторинг)',
  features: '$t(common:features)',
  notifications: '$t(уведомления)',
};

export const ruRu = (__LOCALE_RU__ ? ({
  ...reused,
  cards_and_lists: 'Картотека и списки',
  events_and_video: 'События и видео',
  sources: 'Источники',
  access_control: 'Контроль доступа',
  users: 'Пользователи',
  roles: 'Роли',
  departments: 'Подразделения',
  permission_tags: 'Теги доступа',
  settings_and_catalogs: 'Настройки и справочники',
  administration: 'Администрирование',
  other: '',
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  ...reused,
  cards_and_lists: 'Card index and lists',
  events_and_video: 'Events and Video',
  sources: 'Sources',
  access_control: 'Access control',
  users: 'Users',
  roles: 'Roles',
  departments: 'Departments',
  permission_tags: 'Permission tags',
  settings_and_catalogs: 'Settings and Catalogs',
  administration: 'Administration',
  other: '',
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  ...reused,
  cards_and_lists: 'Fichero y listas',
  events_and_video: 'Eventos y vídeo',
  sources: 'Fuentes',
  access_control: 'Control de acceso',
  users: 'Usuarios',
  roles: 'Roles',
  departments: 'Departamentos',
  permission_tags: 'Etiquetas de permiso',
  settings_and_catalogs: 'Configuración y catálogos',
  administration: 'Administración',
  other: '',
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  ...reused,
  cards_and_lists: 'Fichas e listas',
  events_and_video: 'Eventos e Vídeos',
  sources: 'Fontes',
  access_control: 'Controle de acesso',
  users: 'Usuários',
  roles: 'Funções',
  departments: 'Departamentos',
  permission_tags: 'Etiquetas de permissão',
  settings_and_catalogs: 'Configurações e Catálogos',
  administration: 'Administração',
  other: '',
}) : {}) as Record<string, unknown>;
